import React from "react";
import OrganizerCircle from "./OrganizerCircle";

const GenreList = (props) => {
  const organizerList = props.organizers;
  return (
    <section className="c-section-wrapin">
      {organizerList.length > 0 &&
        React.Children.toArray(
          organizerList.map((organizer) => (
            <div className="flex-row--center">
              <OrganizerCircle
                key={organizer.boothID}
                boothID={organizer.boothID}
                organizerName={organizer.organizerName}
                description={organizer.description}
                boothName={organizer.boothName}
                genre={organizer.genre}
                avatar={organizer.avatar}
              />
              <div className="row-spacer--l"></div>
              <div className="row-spacer--l"></div>
              <OrganizerCircle
                key={organizer.boothID}
                boothID={organizer.boothID}
                organizerName={organizer.organizerName}
                description={organizer.description}
                boothName={organizer.boothName}
                genre={organizer.genre}
                avatar={organizer.avatar}
              />
              <div className="row-spacer--l"></div>
              <div className="row-spacer--l"></div>
              <OrganizerCircle
                key={organizer.boothID}
                boothID={organizer.boothID}
                organizerName={organizer.organizerName}
                description={organizer.description}
                boothName={organizer.boothName}
                genre={organizer.genre}
                avatar={organizer.avatar}
              />
            </div>
          ))
        )}
    </section>
  );
};

export default GenreList;
